import styled from "styled-components";
interface Props {
  type: 'ACTIVE' | 'INACTIVE' | 'PENDING'
}
export const Content = styled.div<Props>`
  width: 80px;
  height: 20px;
  background-color: ${({ theme,type}) => type === 'ACTIVE' ? theme.colors.blue : type === 'INACTIVE' ? theme.colors.red : theme.colors.secondary70};
  color: ${({ theme }) => theme.colors.secondary10};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  border-radius: 8px;
  cursor: pointer;
`;
